import { ConfigService } from '../../../infra/config'
import { BaseRepository } from '../../../infra/base.repository'
import type { PartnerPerson } from './partner-person.entity'

export class PartnersPersonsRepository extends BaseRepository<PartnerPerson> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.toolsApiUrl + '/' + 'partners/persons', token, cache)
    }
}
